import { defineMessages } from 'react-intl';

export const mcpPolicyAlertMessages = defineMessages({
  policyFetchTitle: {
    id: 'oauth.mcp.policyAlert.policyFetch.title',
    defaultMessage: "We couldn't verify permissions for this {productUnit}",
    description:
      'Error title when the policy-fetch network request fails; {productUnit} is "Trello workspace" or "Atlassian site"',
  },
  policyFetchBody: {
    id: 'oauth.mcp.policyAlert.policyFetch.body',
    defaultMessage:
      'Check your connection and try again. If the problem continues, try another {productUnit} or cancel and try again later.',
    description:
      'Error body when the policy-fetch network request fails; {productUnit} is "Trello workspace" or "Atlassian site"',
  },
  unexpectedTitle: {
    id: 'oauth.mcp.policyAlert.unexpected.title',
    defaultMessage: "We couldn't verify permissions for this {productUnit}",
    description:
      'Error title for unexpected policy errors; {productUnit} is "Trello workspace" or "Atlassian site"',
  },
  unexpectedBody: {
    id: 'oauth.mcp.policyAlert.unexpected.body',
    defaultMessage:
      'We’re having trouble showing permissions right now. You can try refreshing the page or <supportLink>contact support</supportLink>.',
    description:
      'Error body for unexpected policy errors, with embedded link to the Atlassian support page',
  },
  missingRedirectTitle: {
    id: 'oauth.mcp.policyAlert.missingRedirect.title',
    defaultMessage: 'Redirect URL is missing',
    description: 'Error title when redirect URL is not provided by the app',
  },
  missingRedirectBody: {
    id: 'oauth.mcp.policyAlert.missingRedirect.body',
    defaultMessage:
      'This app must provide a redirect URL before you can continue. Cancel and contact the app developer.',
    description: 'Error body when redirect URL is not provided by the app',
  },
  domainNotAllowedTitle: {
    id: 'oauth.mcp.policyAlert.redirectNotAllowed.title',
    defaultMessage: 'Access to this domain is restricted',
    description: 'Error title when domain URL is not on the admin allowlist',
  },
  domainNotAllowedBodyLine1: {
    id: 'oauth.mcp.policyAlert.redirectNotAllowed.bodyLine1',
    defaultMessage:
      'Your admin has blocked this domain \"{redirectUrl}\" in your organization’s settings. To request access, contact your organization admin or <allowlistLink>find out about domain restrictions</allowlistLink>.',
    description:
      'Error body for redirect-not-allowed with embedded link to the admin allowlist documentation; {redirectUrl} is interpolated',
  },
});
